"use client";

import { JSX, useEffect, useRef, useState } from "react";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./TabbedContent.module.css";

type Item = {
  id: string | number;
  title: string;
  content: JSX.Element | Function;
  onClick?: () => void;
};

type Props = {
  items: Item[];
  initialItemId?: string | number;
  hideContentPadding?: boolean;
};

export default function TabbedContent(props: Props) {
  const { items, initialItemId, hideContentPadding } = props;

  const [currentItemId, setCurrentItemId] = useState(
    initialItemId ?? (items.length > 0 ? items[0].id : undefined),
  );

  const tabContentRef = useRef<HTMLDivElement | any>(null);

  const currentItem = items.find((item) => item.id === currentItemId);

  const scrollToTop = () => {
    if (tabContentRef.current) {
      tabContentRef.current.scrollTop = 0;
      window.scrollTo({ top: 0 });
    }
  };

  useEffect(() => {
    scrollToTop();
  }, [scrollToTop]);

  return (
    <div className={styles.container}>
      <div className={styles.navTabs}>
        {items.map((item) => (
          <button
            key={item.id}
            className={`${styles.navLink} ${currentItemId === item.id ? styles.navLinkActive : ""}`}
            onClick={() => {
              if (currentItemId === item.id) {
                return;
              }

              setCurrentItemId(item.id);

              if (item.onClick) {
                item.onClick();
              }
            }}
          >
            {item.title}
          </button>
        ))}
      </div>

      <div
        className={UStyles.classNames(
          styles.tabContent,
          hideContentPadding ? styles.tabContentNoPadding : "",
        )}
        ref={tabContentRef}
      >
        {currentItem?.content &&
          (typeof currentItem.content === "function" ? currentItem.content() : currentItem.content)}
      </div>
    </div>
  );
}
